module.exports = __webpack_public_path__ + "img/lock.4b00f045.gif";